import React from 'react';

import { observer } from 'mobx-react';
import { Webhook } from '@bringg-frontend/webhooks-api-internal-stores';

import WebhookFieldsForm from './webhook-fields-form/webhook-fields-form';

interface Props {
	webhook: Webhook;
}

const WebhooksEditFields: React.FC<Props> = ({ webhook }) => {
	const onChange = newNodeValues => {
		webhook.updateNodeValues(newNodeValues);
	};

	const reset = () => {
		webhook.resetWebhookFieldsTree();
	};

	return <WebhookFieldsForm webhook={webhook} onChange={onChange} reset={reset} />;
};

export default observer(WebhooksEditFields);
